
let stickyElement;
let parentElement;
let innerElement;
let topStuckPoint = 0;
let unstuckBoundary = 0;
let innerMaxHeight = 0;


export const updateStickyCalculations = () => {

    if (!stickyElement) stickyElement = document.querySelector(".js-sticky");
    if (!parentElement) parentElement = document.querySelector(".js-sticky-parent");
    if (!innerElement) innerElement = document.querySelector(".js-sticky-inner");

    if (!stickyElement || !parentElement || !innerElement) return;

    // Reset height to measure natural height
    parentElement.style.minHeight = 'auto';
    const currentParentHeight = parentElement.clientHeight;

    // Lock height
    parentElement.style.minHeight = `${currentParentHeight}px`;


    topStuckPoint = parentElement.offsetTop - 1;
    innerMaxHeight = window.innerHeight;
    unstuckBoundary = parentElement.offsetTop + currentParentHeight - window.innerHeight;

    handleScroll();
};


const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY >= topStuckPoint) {
        stickyElement?.classList.add("is-pinned-top");
        if (innerElement) innerElement.style.maxHeight = `${innerMaxHeight}px`;
    } else {
        stickyElement?.classList.remove("is-pinned-top");
        if (innerElement) innerElement.style.maxHeight = 'none';
    }

    if (currentScrollY >= unstuckBoundary) {
        stickyElement?.classList.add("is-unstuck-bottom");
    } else {
        stickyElement?.classList.remove("is-unstuck-bottom");
    }

    if (currentScrollY < topStuckPoint) {
        stickyElement?.classList.remove("is-unstuck-bottom");
    }
};


export const initStickySidebar = () => {
    stickyElement = document.querySelector(".js-sticky");
    parentElement = document.querySelector(".js-sticky-parent");
    innerElement = document.querySelector(".js-sticky-inner");

    if (stickyElement && parentElement) {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', updateStickyCalculations);
      
        updateStickyCalculations();
    }
};

document.addEventListener('DOMContentLoaded', () => {
    initStickySidebar();
});